import { IApiResponse, ISearchResponse } from '../../../common/models/common';
import request from '../../../utils/request';
import { ISearchCmdbCiDbMsSqlInstance, ICmdbCiDbMsSqlInstance, IProcessData } from './cmdbCiDbMsSqlInstance.model';

class CmdbCiDbMsSqlInstanceService {
  ENDPOINT = '/service-now-cmdb-ci-db-mssql-instance';

  public async searchCmdbCiDbMsSqlInstance(
    searchParams?: ISearchCmdbCiDbMsSqlInstance
  ): Promise<IApiResponse<ISearchResponse<ICmdbCiDbMsSqlInstance>>> {
    const url = `${this.ENDPOINT}/search`;
    return request({ url, method: 'POST', data: searchParams }).then((res) => {
      return res.data;
    });
  }

  public async getCmdbCiDbMsSqlInstanceById(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'GET' }).then((res) => {
      return res.data;
    });
  }

  public async saveCmdbCiDbMsSqlInstance(data: ICmdbCiDbMsSqlInstance): Promise<any> {
    const { id, ...restData } = data;
    if (id > 0) {
      const url = `${this.ENDPOINT}/${id}`;
      return request({ url, method: 'PUT', data: restData }).then((res) => {
        return res.data;
      });
    } else {
      const url = `${this.ENDPOINT}`;
      return request({ url, method: 'POST', data: restData }).then((res) => {
        return res.data;
      });
    }
  }

  public async deleteCmdbCiDbMsSqlInstance(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'DELETE' }).then((res) => {
      return res.data;
    });
  }

  public async processData(data: IProcessData): Promise<any> {
    const inputValues = {
      ...data,
      debug: false,
    };
    const url = `back-ground-processes/ad-device-process-data`;
    return request({ url, method: 'POST', data: inputValues }).then((res) => {
      return res.data;
    });
  }

  public async exportExcelFile(searchParams?: ISearchCmdbCiDbMsSqlInstance): Promise<any> {
    const url = `back-ground-processes/export-excel`;
    return request({
      url,
      method: 'POST',
      data: searchParams,
    }).then((res) => {
      return res;
    });
  }
}
export default new CmdbCiDbMsSqlInstanceService();
